import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './app/store';
import router from './utils/router';
import { RemoteErrorTypes } from './utils/enums';
import { StartData } from './models/Station';

export interface GuestState {
    contactInformation?: string | null;
    startData?: StartData | null;
    paymentMethod?: string | null;
    creditCard?: string | null;
    connector?: number;
}

const initialState: GuestState = {
    contactInformation: undefined,
    startData: undefined,
    paymentMethod: undefined,
    creditCard: undefined,
    connector: 1,
};

export const guestSlice = createSlice({
    name: 'guest',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setContactInformation: (
            state,
            action: PayloadAction<string | null | undefined>
        ) => {
            state.contactInformation = action.payload;
        },
        setStartData: (
            state,
            action: PayloadAction<StartData | null | undefined>
        ) => {
            state.startData = action.payload;
        },
        setPaymentMethod: (
            state,
            action: PayloadAction<string | null | undefined>
        ) => {
            state.paymentMethod = action.payload;
        },
        setCreditCard: (
            state,
            action: PayloadAction<string | null | undefined>
        ) => {
            state.creditCard = action.payload;
        },
        setConnector: (state, action: PayloadAction<number>) => {
            state.connector = action.payload;
        },
    },
});

export const {
    setContactInformation,
    setStartData,
    setPaymentMethod,
    setCreditCard,
    setConnector,
} = guestSlice.actions;
export const actions = guestSlice.actions;

export const selectContactInformation = (state: RootState) =>
    state.guest.contactInformation;
export const selectStartData = (state: RootState) => state.guest.startData;
export const selectPaymentMethod = (state: RootState) =>
    state.guest.paymentMethod;
export const selectCreditCard = (state: RootState) => state.guest.creditCard;
export const selectConnector = (state: RootState) => state.guest.connector;

export default guestSlice.reducer;
